export default "__VITE_ASSET__3c1856bd__"